import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FooterPrimaryComponent } from '../../components/footer-primary/footer-primary.component';
import { NavbarPrimaryComponent } from '../../components/navbar-primary/navbar-primary.component';
import {
  FooterContentService,
  FooterDocument
} from '../../services/footer-content.service';

@Component({
  selector: 'app-committees',
  imports: [RouterLink, NavbarPrimaryComponent, FooterPrimaryComponent],
  templateUrl: './committees.component.html',
  styles: `
    :host {
      height: 100vh;
      display: flex;
      flex-direction: column;
    }

    main {
      flex: 1;
      padding-top: 64px;
    }
  `
})
export class CommitteesComponent {
  private readonly footerContent = inject(FooterContentService);

  committees: FooterDocument[] = [];
  loading = true;
  error = false;

  constructor() {
    this.footerContent.getDocuments('committees').subscribe({
      next: (committees) => {
        this.committees = committees;
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }
}
